module.exports = __webpack_public_path__ + "img/point.2ed05b0f.png";